import classnames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Label from "../Label/index";

class TextInput extends Component {
    once = false;
    render() {
        const {
            id,
            name,
            label,
            labelHidden,
            defaultValue,
            placeholder,
            error,
            showErrorMessage = true,
            type,
            onTouchStart,
            onChange,
            helpText,
            dataTestId,
            className,
            inputRef,
            onBlur,
            ...rest
        } = this.props;

        const setClasses = classnames("field",
            error && "is-danger");

        const helpMarkup = (helpText && helpText !== "") ? <div className="helpText">{helpText}</div> : null;

        const labelMarkup = (
            <Label className="label" htmlFor={id} label={`${label}`} />
        );

        const formControl = classnames("input", error && "is-danger", className && className);

        const checklistMarkup = (type === "checklist" && !error) ? (
            <span className="icon is-left">
                <i className="fas fa-list" />
            </span>
        ) : "";


        const tagMarkup = (type === "tag" && !error) ? (
            <span className="icon is-left">
                <i className="fas fa-tags" />
            </span>
        ) : "";

        const passwordMarkup = (type === "password" && !error) ? (
            <span className="icon is-left">
                <i className="fas fa-lock" />
            </span>
        ) : "";

        const emailMarkup = (type === "email" && !error) ? (
            <span className="icon is-left">
                <i className="fas fa-envelope" />
            </span>
        ) : "";

        const searchMarkup = (type === "search" && !error) ? (
            <span className="icon is-right">
                <i className="fas fa-search" />
            </span>
        ) : "";

        const dateMarkup = (type === "date" && !error) ? (
            <span className="icon is-right">
                <i className="far fa-calendar-alt" />
            </span>
        ) : "";

        const setClassesControl = classnames("control",
            (emailMarkup !== "") && "has-icons-left",
            (passwordMarkup !== "") && "has-icons-left",
            (tagMarkup !== "") && "has-icons-left",
            (checklistMarkup !== "") && "has-icons-left",
            (dateMarkup !== "" || searchMarkup !== "")
            && "has-icons-right", error && "has-icons-right");
        return (
            <div className={setClasses}>
                {label && !labelHidden && labelMarkup}
                <div className={setClassesControl}>
                    <input
                        id={id}
                        onTouchStart={onTouchStart}
                        name={name}
                        autoComplete="off"
                        placeholder={placeholder}
                        type={type}
                        defaultValue={defaultValue}
                        onChange={(event) => {
                            onChange(event);
                        }}
                        onBlur={onBlur}
                        ref={inputRef}
                        data-testid={dataTestId}
                        className={formControl}
                        {...rest}
                    />
                    {error && <span className="icon is-small is-right">
                        <span className="has-text-red">
                            <i className="fas fa-exclamation-triangle" />
                        </span>
                    </span>}
                    {dateMarkup}
                    {emailMarkup}
                    {searchMarkup}
                    {passwordMarkup}
                    {tagMarkup}
                    {checklistMarkup}
                </div>
                {error && showErrorMessage && <p className="help">{error}</p>}
                {helpMarkup}
            </div>
        );
    }
}

TextInput.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    label: PropTypes.string,
    labelHidden: PropTypes.bool,
    type: PropTypes.oneOf(["checklist", "text", "email", "password", "date", "number", "textarea", "search",
        "time", "tag"]),
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    required: PropTypes.bool,
    ref: PropTypes.any,
    inputRef: PropTypes.any,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    defaultValue: PropTypes.any,
    onTouchStart: PropTypes.func,
    dataTestId: PropTypes.string,
    className: PropTypes.string,
    showErrorMessage: PropTypes.bool
};

export default TextInput;
